const CARGO_CORP_URL = 'cargo-corp/v1' as const

export function withCargoCorp<T extends string>(path: T) {
  return `${CARGO_CORP_URL}/${path}` as const
}

export function withCargoCorpClient<T extends string>(path: T) {
  return `${CARGO_CORP_URL}/client/${path}` as const
}
